export enum MaintenanceJobStatus {
  OK = 'OK',
  Expired = 'Expired',
  Expiring = 'Expiring',
  InProgress = 'inProgress',
}

export const MAINTENANCE_JOB_STATUSES = [
  MaintenanceJobStatus.OK,
  MaintenanceJobStatus.Expired,
  MaintenanceJobStatus.Expiring,
  MaintenanceJobStatus.InProgress,
];
